import { RouterProvider } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import router from './Routes';
import client from './Cache';
import ToastProvider from './components/ToastProvider';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { PWAInstallPrompt } from './components/PWAInstallPrompt';
import { OfflineFallback } from './components/OfflineFallback';

function AppContent() {
  const { effectiveTheme } = useTheme();

  return (
    <Theme appearance={effectiveTheme}>
      <AuthProvider>
        <ToastProvider>
          <RouterProvider router={router} />
          <PWAInstallPrompt />
          <OfflineFallback />
        </ToastProvider>
      </AuthProvider>
    </Theme>
  );
}

function App() {
  return (
    <ApolloProvider client={client}>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </ApolloProvider>
  );
}

export default App;
